<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bpKI3P/tc-custom/9781558616332.jpg?1737688554102" alt="This image is the cover for the book Now, Voyager, Femmes Fatales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Now, Voyager, Femmes Fatales
      </h1>
      <p class="bookDescription body article font2">
        <b>The iconic American melodrama that inspired the 1943 cult classic film starring Bette Davis. “Charlotte Vale a timeless and very sophisticated Cinderella.” —Patricia Gaffney, <i>New York Times</i> bestselling author</b><br/><br/> “Don’t let’s ask for the moon! We have the stars!”<br/><br/> The film <i>Now, Voyager</i> concludes with these famous words, which reaffirmed Bette Davis’s own stardom and changed the way Americans smoked cigarettes. But few fans of this rich story know its source. Olive Higgins Prouty’s 1941 novel provides a rich, complex portrait of the inner life of its protagonist and the society she inhabits. Over half a century later, it still offers fresh and quietly radical takes on psychiatric treatment, traditional family life, female desire, and women’s agency.<br/><br/> Boston blueblood Charlotte Vale has led an unhappy, sheltered life. Dowdy, repressed, and pushing forty, Charlotte finds salvation in the unlikely form of a nervous breakdown, placing her at a sanitarium, where she undergoes treatment to rebuild her ravaged self-esteem and uncover her true intelligence and charm.<br/><br/><b>Femmes Fatales</b> restores to print the best of women’s writing in the classic pulp genres of the mid-20th century. From mystery to hard-boiled noir to taboo lesbian romance, these rediscovered queens of pulp offer subversive perspectives on a turbulent era.<br/><br/><b>“Like the film it inspired, Olive Higgins Prouty’s <i>Now, Voyager</i> is as striking for the conventions it bucks as for the ones it embraces: a vivid reminder of a time when people crossed the ocean in liners and wore hats, and a hymn to an American ideal of social, moral, and emotional independence.” —David Leavitt, author of <i>Shelter in Place</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olive Higgins Prouty, Judith Mayne
      </h2>
      
      <p class="authorDescription body article"><B>Olive Higgins Prouty</B> (1882-1974), like many of her characters a wealthy Bostonian, was the author of ten novels, including <I>Stella Dallas</I> (1923), which became the basis for three films and a long-running radio serial. A graduate of Smith College, Prouty endowed a writer's scholarship at Smith that was received by Sylvia Plath, who later portrayed her patron unflatteringly in <I>The Bell Jar</I>.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b8551c4